import React, { PropTypes } from 'react';
import moment from 'moment';

import WeekModal from './WeekModal';

class WeekItem extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    // EVENT HANDLERS

    _handleModalShow (title, timesheets) {
        let week = this.props.timesheets.week % 100;
        let startDate = moment(this.props.timesheets.startDate, "YYYY-MM-DD").format("DD.MM.");
        let endDate = moment(this.props.timesheets.endDate, "YYYY-MM-DD").format("DD.MM");

        let modal = <WeekModal
                        handleReload={this.props.handleReload}
                        handleClose={this.handleCloseModal}
                        subtitle={title}
                        timesheets={timesheets}
                        title={startDate + "- " + endDate + " (Week " + week + ")"}
                        />;

        this.setState({
            showModal: true,
            modal: modal
        });
    }

    handleAllClick = () => {
        if (this.props.timesheets.all.length == 0) return;

        this._handleModalShow("All timesheets", this.props.timesheets.all);
    }

    handleApprovedClick = () => {
        if (this.props.timesheets.approved.length == 0) return;

        this._handleModalShow("Approved timesheets", this.props.timesheets.approved);
    }

    handleCloseModal = () => { this.setState({ showModal: false }); }

    handleEmptyClick = () => {
        if (this.props.timesheets.empty.length == 0) return;

        this._handleModalShow("Timesheets not ready for submit", this.props.timesheets.empty);
    }

    handleReadyToSubmitClick = () => {
        if (this.props.timesheets.readyToSubmit.length == 0) return; 

        this._handleModalShow("Timesheets ready for submit", this.props.timesheets.readyToSubmit);
    }

    handleSubmittedClick = () => {
        if (this.props.timesheets.submitted.length == 0) return; 

        this._handleModalShow("Submitted timesheets", this.props.timesheets.submitted);
    }

    handleWithRejectedRecordsClick = () => {
        if (this.props.timesheets.withRejectedRecords.length == 0) return; 

        this._handleModalShow("Timesheets with rejected records", this.props.timesheets.withRejectedRecords);
    }

    // RENDER METHOD

    render = () => {
        let week = this.props.timesheets.week % 100;
        let startDate = moment(this.props.timesheets.startDate, "YYYY-MM-DD").format("DD.MM.");
        let endDate = moment(this.props.timesheets.endDate, "YYYY-MM-DD").format("DD.MM");

        let color = "rgba(153, 34, 0, 1)";
        let backgroundColor = "rgba(153, 34, 0, 0.07)";
        if (this.props.timesheets.all.length === this.props.timesheets.approved.length) {
            color = "rgba(34, 153, 0, 1)";
            backgroundColor = "rgba(34, 153, 0, 0.07)";
        }

        if (this.props.timesheets.all.length === 0) {
            return null;
        }

        return (
            <tr style={{"color" : color, "background" : backgroundColor}}>
                <td><div>
                {
                    this.state.showModal ? this.state.modal : null
                }
                {startDate} - {endDate} (Week {week}) </div></td>
                <td className="text-center"><div onClick={this.handleEmptyClick} style={{"cursor" : "pointer"}}> {this.props.timesheets.empty.length} </div></td>
                <td className="text-center"><div onClick={this.handleReadyToSubmitClick} style={{"cursor" : "pointer"}}> {this.props.timesheets.readyToSubmit.length} </div></td>
                <td className="text-center"><div onClick={this.handleWithRejectedRecordsClick} style={{"cursor" : "pointer"}}> {this.props.timesheets.withRejectedRecords.length} </div></td>
                <td className="text-center"><div onClick={this.handleSubmittedClick} style={{"cursor" : "pointer"}}> {this.props.timesheets.submitted.length} </div></td>
                <td className="text-center"><div onClick={this.handleApprovedClick} style={{"cursor" : "pointer"}}> {this.props.timesheets.approved.length} </div></td>
                <td className="text-center"><div onClick={this.handleAllClick} style={{"cursor" : "pointer"}}> {this.props.timesheets.all.length} </div></td>
            </tr>
        );
    }
}

WeekItem.propTypes = {
    handleReload: PropTypes.func,
    timesheets: PropTypes.object
};

WeekItem.defaultProps = {
    timesheets: {
        empty: [],
        readyToSubmit: [],
        withRejectedRecords: [],
        submitted: [],
        approved: [],
        all: []
    }
};

export default WeekItem;



/** WEBPACK FOOTER **
 ** ./src/app/components/WeekItem.js
 **/